module.exports = __webpack_public_path__ + "img/965-8fd5ac.png";